import { toValue } from 'vue'
import { defineStore } from 'pinia'
import { pick as _pick } from 'lodash'
import Product from '@/classes/products/Product'
import Products from '@/classes/products/Products'

export const useProductStore = defineStore('ProductStore', {
  state: () => ({
    products: {},
    product: {},
    loader: false,
    error: {}
  }),
  getters: {
    getProducts: state => ({ query, reload, dependencies } = {}) => {
      return state.$getItems({
        resource: 'products',
        query,
        reload,
        dependencies,
        fetch: () => state.fetchProducts({ query })
      })
    },
    getProduct: state => ({ id }) => state.$getItem({
      resource: 'product',
      key: id,
      fetch: () => state.fetchProduct({ id })
    })
  },
  actions: {
    fetchProducts ({ query }) {
      return this.$fetchItems({
        endpoint: '/api/v1/products',
        resource: 'products',
        model: Products,
        query
      })
    },
    async fetchProduct ({ id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$fetchItem({
        endpoint: `/api/v1/products/${toValue(id)}`,
        resource: `product.${toValue(id)}`,
        model: Product
      })
    },
    async patchProduct ({ params, id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$patchItem({
        endpoint: `/api/v1/products/${toValue(id)}`,
        resource: `product.${toValue(id)}`,
        model: Product,
        params: {
          product: _pick(new Product(params).to_database, Object.keys(params))
        }
      })
    },
    postProduct ({ params }) {
      return this.$postItem({
        endpoint: '/api/v1/products',
        resource: 'product.{id}',
        model: Product,
        params: {
          product: new Product(params).to_database
        }
      })
    },
    async postProductStock ({ id, params }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$postItem({
        endpoint: `/api/v1/products/${toValue(id)}/stock`,
        resource: 'product.{id}',
        model: Product,
        params
      })
    },
    async deleteProduct ({ id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$deleteItem({
        endpoint: `/api/v1/products/${toValue(id)}`,
        resource: toValue(id)
      })
    }
  }
})